module.exports = __webpack_public_path__ + "img/hatchback.d69a02b7.svg";